import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { Avatar, Box, Card, CardContent } from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { getWinner } from "../../api/tournament.api";

const WinnerCard = ({ tournament }) => {
  const [winner, setWinner] = useState();
  useEffect(() => {
    if (tournament.winner) {
      getWinner(tournament.id)
        .then((response) => {
          setWinner(response.data);
        })
        .catch((error) => console.log(error));
    }
  }, [tournament]);

  return (
    <>
      {winner && tournament && tournament.winner && (
        <Card
          className="winner-border"
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            minWidth: 150,
            maxWidth: 150,
            minHeight: 140,
            maxHeight: 140,
            border: 1,
            borderColor: "#ff8100",
          }}
        >
          <CardContent>
            <Box style={{ alignItems: "center", justifyContent: "center", display:"flex" }}>
              <EmojiEventsIcon color="primary" />
              <Typography color="primary">Winner</Typography>
            </Box>
            <Box style={{ alignItems: "center", justifyContent: "center", display:"flex", flexDirection: "column" }}
              sx={{ textAlign: "center", alignmentBaseline: "baseline" }}
            >
              <Avatar
                sx={{ width: 64, height: 64 }}
                alt={winner.nickname}
                src={`/static/images/${winner.imageName ?? "default.jpg"}`}
              />

              <Typography
                sx={{
                  fontSize: 16,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {winner.name}
              </Typography>
            </Box>
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default WinnerCard;
